// extracted by mini-css-extract-plugin
export var buttonWrapperStyle = "carousel_control_text-module--buttonWrapperStyle--G9oRw";
export var isActiveStyle = "carousel_control_text-module--isActiveStyle--UVsl-";